export const recipientMessagesManagementDefaultColumns = [
  { label: 'Status', value: 'status' },
  { label: 'Método', value: 'method' },
  { label: 'Assunto', value: 'subject' },
  { label: 'Data e hora de envio', value: 'sent_at' },
];
